import React, { useState } from 'react'; // Import useState hook for managing component state
import CustomButton from './CustomButton/CustomButton'; // Assuming CustomButton is in the same directory or adjust path
import '../styles/_service-card.scss'; // Import the CSS file for styling the flip card (ensure this path is correct)

const FeaturedCaseStudy = () => {
  const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL; 
  const [isFlipped, setIsFlipped] = useState(false);

  // Function to handle the click event on the "Press Play" button.
  // This function will toggle the 'isFlipped' state.
  const handlePressPlayClick = () => {
    setIsFlipped(!isFlipped); // Toggles the boolean value of isFlipped
  };

  return (
    <section className="py-3">
      <div className="container py-5">
        <div className="row">
          <div className="col">
            {/* The main container for the flip card.
                The 'is-flipped' class is conditionally added based on the 'isFlipped' state.
                This class triggers the CSS transform for the flip animation. */}
            <div className={`service-card hover-lift ${isFlipped ? 'is-flipped' : ''}`}>
              <div className="service-card-inner">
                {/* Front of the card */}
                <div className="service-card-front">
                  <h2 className="font-bold text-black text-uppercase">
                    THE STORY OF XBOX
                  </h2>
                  <p className="text-black mb-0">
                    The Launching of a Billion Dollar Brand that Changed Gaming Forever
                  </p>
                  <div className="row text-center mt-5">
                    <div className="col">
                      <CustomButton
                        label="Press Play"
                        variant="red"
                        size="small"
                        onClick={handlePressPlayClick} // Attach the click handler to this button
                      />
                    </div>
                    </div>
                  <img
                    src={`${awsImageBaseUrl}images/XBOX-IMAGE_3.png`}
                    className="img-fluid" // Bootstrap class for responsive images
                    alt="Xbox"
                    loading="lazy" // Defer loading of the image until it's in the viewport
                  />
                  {/* CustomButton component. When clicked, it calls handlePressPlayClick. */}

                </div>

                {/* Back of the card (content displayed when flipped) */}
                <div className="service-card-back">
                  <p><strong>XBox Case Study – The Launching of a Billion Dollar Brand that Changed Gaming Forever</strong></p>
                  <p>When Microsoft set out to challenge the console gaming giants in the early 2000s, it wasn’t just launching a device—it was launching a movement. The stakes were high, the vision was audacious, and the technology was groundbreaking. Microsoft needed more than a product name—it needed a name that would command attention, ignite imaginations, and define an entirely new era of entertainment. That name was <strong>XBox®</strong>, and it was forged by the brand architects at Brand Acumen Studios.</p>
                  <p><strong>The Challenge: Name a Revolution</strong></p>
                  <p>Back in 2001, Microsoft wasn’t known as a gaming company. The console market was dominated by brands like PlayStation and Nintendo. The internal codename for the project was “DirectX Box,” a reference to Microsoft’s DirectX graphics technology. But the product needed a name with sharper edges, broader cultural reach, and brand longevity. It needed to be simple, powerful, and unforgettable.</p>
                  <p><strong>The Concept: Mystery Meets Machinery</strong></p>
                  <p>Brand Acumen envisioned a name built on a compelling paradox. “X” was chosen to signify the unknown—the thrilling frontier of unexplored virtual worlds. It was bold, angular, and evocative of excitement and innovation. The “Box” grounded the brand in physicality. It wasn’t just theoretical tech—it was something you could hold, plug in, and command. Together, XBox became a container of endless possibility—a sleek union of imagination and engineering.</p>
                  <p><strong>Phonetic Power, Cultural Impact</strong></p>
                  <p>Short. Punchy. Visually iconic. XBox achieved what few product names do: instant global recognition. The name slid seamlessly into gamer vernacular and pop culture. It lent itself to clean logo design, strong digital UX, and future-proof brand extensions (XBox 360, XBox One, XBox Series X/S). It sounded futuristic but accessible, mysterious yet grounded. In short, it was everything a global tech and entertainment brand needed to be.</p>
                  <p><strong>Results That Speak Louder Than Hype</strong></p>
                  <p>Since launch, XBox has become one of the most recognized and respected names in gaming. As of 2024, the brand has sold over 170 million consoles worldwide. According to IGN, XBox “forever changed the gaming landscape,” while TechRadar praises it as “a cornerstone of digital entertainment evolution.” Its Game Pass subscription service and cloud-based gaming innovations continue to earn accolades for pushing the industry forward.</p>
                  <p><strong>Beyond the Console</strong></p>
                  <p>XBox has grown into an ecosystem—spanning consoles, cloud gaming, community networks, exclusive titles, and hardware peripherals. Its name continues to anchor a vast, evolving portfolio while staying true to its original promise: access to limitless adventure.</p>
                  <p><strong>The Takeaway for Brand Leaders</strong></p>
                  <p>At Brand Acumen Studios, we believe a great name is not just a label—it’s a launchpad. XBox is a case study in what happens when sound strategy meets daring creativity. The name helped Microsoft rewrite the rules of a fiercely competitive industry and build a cultural icon.</p>
                  <p>With XBox, we didn’t just name a gaming console—we named the future of play.</p>
                  <div className="row text-center mt-5">
                    <div className="col">
                      <CustomButton
                        label="Return"
                        variant="red"
                        size="small"
                        onClick={handlePressPlayClick} // Attach the click handler to this button
                      />
                    </div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedCaseStudy;